jQuery(document).ready(function ($) {

    $('.js-search-input').on('keyup', function() {
        var sanitized = $(this).val().replace(/[<>~;{}()[\]:=]/g, '');
        $(this).val(sanitized);
    });


    function initDropdownFilter() {
        const $dropdown = $('.dropdownFilter');

        $dropdown.each(function () {
            const $container = $(this);
            const $btn = $container.find('.personal');
            const $list = $container.find('.list');
            const $items = $list.find('.item input');

            // Torna o botão focável
            $btn.attr('tabindex', 0);

            // Abre/fecha menu com click ou teclado
            $btn.on('click keydown', function (e) {
                if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    const expanded = $list.attr('aria-expanded') === 'true';
                    $list.attr('aria-expanded', !expanded);
                    $list.toggleClass('active').slideToggle('slow');
                }
            });

            // Atualiza colunas e aria-checked ao clicar nos checkboxes
            $items.on('change', function () {
                const col = $(this).val();
                const checked = $(this).is(':checked');

                $(this).closest('.item').attr('aria-checked', checked);

                if (checked) {
                    $("#tableHistoryApi tr ." + col).removeClass('hidden');
                } else {
                    $("#tableHistoryApi tr ." + col).addClass('hidden');
                }
            });

            // Permite marcar/desmarcar com Enter ou Espaço
            $items.on('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    $(this).prop('checked', !$(this).prop('checked')).trigger('change');
                }
            });
        });

        // Fecha com Esc
        $(document).on('keydown', function (e) {
            if (e.key === 'Escape') {
                $dropdown.each(function () {
                    const $btn = $(this).find('.personal');
                    const $list = $(this).find('.list');
                    if ($list.attr('aria-expanded') === 'true') {
                        $list.attr('aria-expanded', 'false').removeClass('active').slideUp('slow');
                        $btn.focus();
                    }
                });
            }
        });

        // Fecha clicando fora
        $(document).on('click', function (e) {
            $dropdown.each(function () {
                const $btn = $(this).find('.personal');
                const $list = $(this).find('.list');
                if (!$btn.is(e.target) && !$list.is(e.target) && $list.has(e.target).length === 0) {
                    if ($list.attr('aria-expanded') === 'true') {
                        $list.attr('aria-expanded', 'false').removeClass('active').slideUp('slow');
                    }
                }
            });
        });
    }
    initDropdownFilter();

    /*--------------------------------------------------------------
    ## Remove hash# do href (href="#")
    --------------------------------------------------------------*/
    $("nav a[href='#']").removeAttr("href");

    /*--------------------------------------------------------------
    ## Remove clique da página "mãe" das internas
    --------------------------------------------------------------*/
    $("#breadcrumbs a.bread-parent").attr("href", "javascript:void(0)");

    /*--------------------------------------------------------------
    ## Abre/Fecha modal de busca
    --------------------------------------------------------------*/
    $(".js-trigger-search").click(function (e) {
        e.preventDefault();
        $(".js-target-search").fadeToggle("linear");
        $('.js-target-search input').focus();
    });

    $(".js-shutdown-search").click(function () {
        $(".js-target-search").removeClass("active").fadeToggle("linear");
    });

    /*--------------------------------------------------------------
    ## Cotação - Live update
    --------------------------------------------------------------*/
    if (document.querySelector(".homePage__quotes")) {
        var MZStockInfo = new MZIQ_StockInfo();
        var langCodeFormatted = lang.split("-")[0];
        var decimalConfig = {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        };
        var decimalConfigVol = {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        };

        var options = {
            language: langCodeFormatted,
            stockinfoId: stockInfoId,
            template: {
                type: "raw"
            },
            rawInit: function (data) {
                var tickers = data.tickers.concat(data.indexes);
                var TICKER = tickers[0];
                var IBOV = tickers[1];

                // var date = TICKER.info.date.substr(-5).replace("-", "/");
                // var time = TICKER.info.time.substr(0, 5);
                // var fullTime = date + " " + time + " delay 15 min.";
                // $(".quotes__update span").html(fullTime);

                $(".TICKER.name").html(TICKER.ticker);
                $(".TICKER.price").html("R$ " + TICKER.info.price.toLocaleString(lang));
                $(".TICKER.variation").html(TICKER.info.var.toLocaleString(lang, decimalConfig) + "%");
                if (TICKER.info.var > 0) {
                    $(".TICKER.variation").addClass("up");
                } else {
                    $(".TICKER.variation").addClass("down");
                }

                $(".INDEX.name").html(IBOV.ticker);
                $(".INDEX.price").html(IBOV.info.price.toLocaleString(lang));
                $(".INDEX.variation").html(IBOV.info.var.toLocaleString(lang, decimalConfigVol) + "%");
                if (IBOV.info.var > 0) {
                    $(".INDEX.variation").addClass("up");
                } else {
                    $(".INDEX.variation").addClass("down");
                }
            }
        };
        MZStockInfo.initialize(options);
    }

    /*--------------------------------------------------------------
    ## Header - Font-size buttons
    --------------------------------------------------------------*/
    var fontIndex = 3;
    var fontElements = $('span,p,li,a,h1,h2,h3,h4,h5,h6,strong,input,select,button');

    // Função para associar clique e teclado
    function handleAction($el, callback) {
        $el.on("click", function (e) {
            e.preventDefault();
            callback();
        });

        $el.on("keydown", function (e) {
            if (e.key === "Enter" || e.key === " " || e.keyCode === 13 || e.keyCode === 32) {
                e.preventDefault();
                callback();
            }
        });
    }

    // Aumentar fonte
    handleAction($(".increase-font"), function () {
        $(".decrease-font").css("opacity", "1");
        if (fontIndex < 7) {
            fontIndex++;
            fontElements.css("font-size", function () {
                return parseInt($(this).css('font-size')) + 2 + 'px';
            });
        }
        if (fontIndex === 7) {
            $(".increase-font").css("opacity", "0.5");
        }
    });

    // Diminuir fonte
    handleAction($(".decrease-font"), function () {
        $(".increase-font").css("opacity", "1");
        if (fontIndex > 0) {
            fontIndex--;
            fontElements.css("font-size", function () {
                return parseInt($(this).css('font-size')) - 2 + 'px';
            });
        }
        if (fontIndex === 0) {
            $(".decrease-font").css("opacity", "0.5");
        }
    });

    /*--------------------------------------------------------------
    ## Acessibilidade - Contraste
    --------------------------------------------------------------*/
    var Contrast = {
        storage: "contrastState",
        cssClass: "contrast",
        currentState: null,
        check: checkContrast,
        getState: getContrastState,
        setState: setContrastState,
        toogle: toogleContrast,
        updateView: updateViewContrast,
    };

    window.toggleContrast = function (e) {
        Contrast.toogle();
    };

    Contrast.check();

    function checkContrast() {
        this.updateView();
    }

    function getContrastState() {
        return localStorage.getItem(this.storage) === "true";
    }

    function setContrastState(state) {
        localStorage.setItem(this.storage, "" + state);
        this.currentState = state;
        this.updateView();
    }

    function updateViewContrast() {
        var body = document.body;

        if (this.currentState === null) this.currentState = this.getState();

        if (this.currentState) body.classList.add(this.cssClass);
        else body.classList.remove(this.cssClass);
    }

    function toogleContrast() {
        this.setState(!this.currentState);
    }

    // Menus do header acessiveis
    function menu_header() {
        let keyboardNavigation = false;

        // Detecta navegação por teclado
        $(window).on('keydown', function(e) {
            if (e.key === "Tab") {
                keyboardNavigation = true;
            }
        });

        // Clique com mouse desativa navegação por teclado
        $(window).on('mousedown', function() {
            keyboardNavigation = false;
        });

        // Torna itens sem href focáveis
        $('.header__nav__menu .menu-item > a').each(function() {
            if (!$(this).attr('href')) {
                $(this).attr('tabindex', '0');
            }
        });

        // Itera sobre cada item que tem submenu
        $('.header__nav__menu .menu-item-has-children').each(function() {
            const $item = $(this);
            const $submenu = $item.children('.sub-menu');
            const $parentLink = $item.children('a'); // Link principal (ex: "nossos etfs")

            // Abre submenu quando qualquer link do item recebe foco
            $item.find('a').on('focus', function() {
                if (keyboardNavigation) {
                    $submenu.show();
                    $item.addClass('focus');
                }
            });

            // --- INÍCIO DA CORREÇÃO ---
            // Quando 'Tab' for pressionado no link principal, move o foco para o submenu
            $parentLink.on('keydown', function(e) {
                // Verifica se a tecla é Tab (e não Shift+Tab) e se o submenu está visível
                if (e.key === 'Tab' && !e.shiftKey && $submenu.is(':visible')) {
                    e.preventDefault(); // Impede o 'Tab' de pular para o próximo item do menu principal
                    $submenu.find('a').first().focus(); // Coloca o foco no primeiro item do submenu
                }
            });
            // --- FIM DA CORREÇÃO ---

            // Fecha o submenu quando o foco sai de todo o componente (item principal + submenu)
            $item.find('a').on('blur', function() {
                setTimeout(() => {
                    // Se nenhum link dentro deste item (incluindo o submenu) estiver focado...
                    if ($item.find(':focus').length === 0) {
                        $submenu.hide();
                        $item.removeClass('focus');
                    }
                }, 10);
            });

            // Hover para mouse
            $item.hover(
                function() {
                    // Não interfere se a navegação por teclado estiver ativa
                    if (!keyboardNavigation) {
                        $submenu.show();
                        $item.addClass('hover');
                    }
                },
                function() {
                    if (!keyboardNavigation) {
                        $submenu.hide();
                        $item.removeClass('hover');
                    }
                }
            );
        });
    }

    menu_header();
});
